import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=a62ffb08&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=a62ffb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62ffb08",
  null
  
)

export default component.exports